const highlights = [
  { icon: 'ri-sun-line', text: 'Solar Panels' },
  { icon: 'ri-battery-charge-line', text: 'Battery Storage' },
  { icon: 'ri-building-line', text: 'Commercial Solar' },
  { icon: 'ri-car-line', text: 'EV Charging' },
];

export default function SolarCTA() {
  return (
    <section className="relative overflow-hidden py-20 md:py-28">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20aerial%20view%20of%20sunlit%20Australian%20farmland%20with%20large%20solar%20farm%20array%20of%20hundreds%20of%20panels%20gleaming%20in%20sunset%20golden%20light%2C%20vast%20sky%20with%20warm%20orange%20and%20gold%20tones%2C%20epic%20clean%20energy%20landscape%2C%20cinematic%20photography%20style&width=1800&height=700&seq=solar-cta-au-2026&orientation=landscape"
          alt="Australian solar farm generating clean renewable energy"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        {/* Strong left-to-right dark ramp */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/97 via-black/90 to-black/65" />
        {/* Top + bottom fade */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-black/50" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-10">
        {/* Backdrop panel for guaranteed contrast */}
        <div
          className="max-w-2xl rounded-2xl"
          style={{
            background: 'linear-gradient(135deg, rgba(0,0,0,0.50) 0%, rgba(0,0,0,0.20) 100%)',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            padding: '2rem',
          }}
        >
          <div style={{ textShadow: '0 2px 20px rgba(0,0,0,0.90), 0 1px 6px rgba(0,0,0,0.75)' }}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/25 border border-primary-400/40 mb-6">
              <div className="w-2 h-2 rounded-full bg-primary-400 animate-pulse-soft" />
              <span className="text-xs font-semibold text-primary-300 tracking-wide uppercase whitespace-nowrap">Australia&rsquo;s Trusted Renewable Energy Marketplace</span>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-5">
              Ready to Switch to<br />Solar Energy?
            </h2>

            <p className="text-base md:text-lg text-white leading-relaxed mb-4">
              AK Energy is Australia&rsquo;s trusted renewable energy marketplace, connecting customers, businesses and renewable energy providers to accelerate the transition towards cleaner energy solutions.
            </p>

            <p className="text-sm text-white/75 leading-relaxed mb-8">
              Tell us about your energy needs and we&rsquo;ll match you with verified solar providers who can deliver the right solution — whether that&rsquo;s residential solar, commercial solar, or battery storage.
            </p>

            {/* Solution tags */}
            <div className="flex flex-wrap gap-2 mb-9">
              {highlights.map((h) => (
                <span
                  key={h.text}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/15 border border-white/20 text-xs font-semibold text-white whitespace-nowrap"
                >
                  <i className={`${h.icon} text-primary-400`}></i>
                  {h.text}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="/#contact"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-primary-500 text-white hover:bg-primary-400 transition-all duration-200 cursor-pointer"
              >
                Find Solar Energy Providers
                <i className="ri-arrow-right-line text-lg"></i>
              </a>
              <a
                href="/blog"
                className="whitespace-nowrap inline-flex items-center justify-center gap-2 px-8 py-4 text-sm font-semibold rounded-xl bg-white/15 border border-white/30 text-white hover:bg-white/25 transition-all duration-200 cursor-pointer"
              >
                <i className="ri-article-line text-lg"></i>
                Read Solar Guides
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}